import React from 'react';
import { createIcon } from 'components/shared/SVGIcon';

const BarsSolidIcon = createIcon(
  'BarsSolid',
  <path d="M19,3 L5,3 C3.9,3 3,3.9 3,5 L3,19 C3,20.1 3.9,21 5,21 L19,21 C20.1,21 21,20.1 21,19 L21,5 C21,3.9 20.1,3 19,3 Z M8,17 C7.45,17 7,16.55 7,16 L7,11 C7,10.45 7.45,10 8,10 C8.55,10 9,10.45 9,11 L9,16 C9,16.55 8.55,17 8,17 Z M12,17 C11.45,17 11,16.55 11,16 L11,8 C11,7.45 11.45,7 12,7 C12.55,7 13,7.45 13,8 L13,16 C13,16.55 12.55,17 12,17 Z M16,17 C15.45,17 15,16.55 15,16 L15,14 C15,13.45 15.45,13 16,13 C16.55,13 17,13.45 17,14 L17,16 C17,16.55 16.55,17 16,17 Z" />
);

export default BarsSolidIcon;
